module.exports = __webpack_public_path__ + "assets/media/3.f3ae039a.wav";